import React, { useEffect, useState } from 'react';
//import UsuarioForm from './UsuarioForm';
import RestricaoForm from './RestricaoForm';
//import $ from 'jquery';
import api from '../../../services/api';
import momentTZ from 'moment-timezone';
import Pagination from '@material-ui/lab/Pagination';

//import loadingGif from '../../../img/loading-gif.gif';

export default function Restricao() {
	const [restricoes, setRestricoes] = useState([]);
	const [loading, setLoading] = useState(true);
	const [modalVisibleNovo, setModalVisibleNovo] = useState(false);
	const [pageTotal,setPageTotal] = useState(0)

	const [paginaAtual,setPaginaAtual] = useState(1)

	//const [modalVisibleEdit, setModalVisibleEdit] = useState(false);
	//const [usuario, setUsuario] = useState();

	const limite = 10;

	const novoUsuarioModal = React.createRef();

	useEffect(() => {
		buscaRestricoes();
	}, []);

	
	async function buscaRestricoes() {
		try {
			
			setLoading(true)
		//let self = this;
		////console.log('iniciando');
		const response = await api.get(`/admin/restricao/json?offset=0&limit=${limite}`);
		//console.log(response);
		const { data, status } = response;
		////console.log('pesquisado');
		////console.log(status);
		////console.log(data);
		if (status === 200 && data.restricoes) {
			////console.log(data);
			setRestricoes(data.restricoes);
			setLoading(false);
			setPageTotal(data.total)
			setPaginaAtual(1)
		}
		} catch (error) {
			alert('Error' + error);
			console.log(error)
			if (error.response.status === 401) {
				window.location.reload();
			}
			setLoading(false)

		}
		

	}
	async function buscaRestricoesPage(newPage){
		try {
			setLoading(true)
		setPaginaAtual(newPage)
		const offset = (newPage -1) * limite
		const response = await api.get(`/admin/restricao/json?offset=${offset}&limit=${limite}`);
		//console.log(response);
		const { data, status } = response;
		////console.log('pesquisado');
		////console.log(status);
		////console.log(data);
		if (status === 200 && data.restricoes) {
			////console.log(data);
			setPageTotal(data.total)

			setRestricoes(data.restricoes);
			setLoading(false);
		}
			
		} catch (error) {
			console.log(error)
			alert('Error' + error);

			if (error.response.status === 401) {
				window.location.reload();
			}
		}

		

	}

	async function removerRestricao(restricao, setLoading) {
		if (!window.confirm('Deseja realmente apagar esse registro ?')) {
			return;
		}

		//let self = this;

		setLoading(true);

		try {
			const response = api.delete('/admin/restricao/' + restricao.id);
			const { data, status } = response;
			if (status === 200 && data === true) {
				removeListRestricao(restricao);
				setLoading(false);

				return;
			} else {
				//////console.log(response.status);
				//////console.log(response.data);
				alert('Ocorreu algum problema');
				setLoading(false);
			}
		} catch (error) {
			alert('Error' + error);
			if (error.response.status === 401) {
				window.location.reload();
			}
			setLoading(false);
		}

		/* if (! confirm("Deseja realmente apagar esse registro ?")) {
            return;
        }*/
		/*
        let self = this;
        $.ajax({
            url: '/admin/usuario/' + usuario.id,
            method: 'DELETE'
        })
        .then(function(data, status) {
            if (status == "success" && data === true) {
                self.buscarestricoes();
                return;
            }
        })
        */
	}

	function removeListRestricao(restricao) {
		const p = [...restricoes];
		let index = -1;
		for (let i = 0; i < p.length; i++) {
			if (p[i].id === restricao.id) {
				index = i;
			}
		}

		if (index !== -1) {
			p.splice(index, 1);
		}

		setRestricoes([...p]);
	}

	function updateRestricoes(restricao) {
		const p = [...restricoes];
		let index = -1;

		for (let i = 0; i < p.length; i++) {
			if (p[i].id === restricao.id) {
				index = i;
			}
		}

		if (index !== -1) {
			//u.splice(index,1);
			////console.log(p[index]);
			p[index] = restricao;
			////console.log(p[index]);
		} else {
			p.push(restricao);
		}

		setRestricoes([...p]);
	}

	return (
		<div style={{paddingTop:30,paddingLeft:15}} className='Usuario row'>
			<div className='col-md-12 header-page p-3'>
				<h2 className='title'>
					Restrições
					<div className='d-inline-block ml-4'>
						<button
							className='btn btn-sm btn-success'
							data-toggle='modal'
							data-target='#novoUsuarioModal'
							onClick={() => {
								novoUsuarioModal.current.resetForm();
								setModalVisibleNovo(true);
							}}>
							Nova Restrição
						</button>
					</div>
				</h2>
				<RestricaoForm
					ref={novoUsuarioModal}
					elementId='novoUsuarioModal'
					callback={updateRestricoes}
					modalVisible={modalVisibleNovo}
					setModalVisible={setModalVisibleNovo}
				/>
			</div>
			<div className='col-md-12'>
				<div className='card border-0 mt-4'>
					<div className='card-body'>
						<div className='row'>
							<div className='col-md-12 mb-2'>
								<div className='float-right'>
								{pageTotal > 0 && !loading && <Pagination
											className='float-right'
											shape='rounded'
											count={pageTotal}
											siblingCount={2}
											boundaryCount={2}
											page={paginaAtual}
											onChange={(event, value) => {
												buscaRestricoesPage(value);
											}}
										/>}
								</div>
							</div>
							<div className='col-md-12'>
								<table className='table'>
									<thead>
										<tr>
											<th>Tipo</th>
											<th>Texto</th>
											<th>Situação</th>
											<th>Expiração</th>
											<th></th>
										</tr>
									</thead>
									{loading ? (
										<tbody>
											<tr>
												<td>{<div className='Skeleton'></div>}</td>
												<td>
													{' '}
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
											</tr>
											<tr>
												<td>{<div className='Skeleton'></div>}</td>
												<td>
													{' '}
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
											</tr>
											<tr>
												<td>{<div className='Skeleton'></div>}</td>
												<td>
													{' '}
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
											</tr>
										</tbody>
									) : (
										<tbody>
											{restricoes.map((restricao) => (
												<RestricaoContainer
													restricao={restricao}
													updateRestricoes={updateRestricoes}
													removerRestricao={removerRestricao}
												/>
											))}
										</tbody>
									)}
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function RestricaoContainer(props) {
	const { restricao, updateRestricoes } = props;

	const [modalVisibleEdit, setModalVisibleEdit] = useState(false);

	//const [loading, setLoading] = useState(false);
	//console.log(restricao);

	//return null;

	const statusOptions = ['Inativo', 'Temporário', 'Permanente'];

	//1 temporario 2 permanente

	return (
		<tr key={restricao.id}>
			{
				<RestricaoForm
					elementId={'editarrestricao' + restricao?.id + 'Modal'}
					item={restricao}
					callback={updateRestricoes}
					modalVisible={modalVisibleEdit}
					setModalVisible={setModalVisibleEdit}
				/>
			}
			<td>{restricao.tipo}</td>
			<td>{restricao.texto}</td>
			<td>{statusOptions[restricao.status]}</td>
			<td>
				{momentTZ
					.tz(restricao.expiracao, 'America/Sao_Paulo')
					.format('DD/MM/YYYY H:mm:ss')}
			</td>
			<td>
				<div className='float-right'>
					<button
						onClick={(e) => {
							e.preventDefault();
							//setrestricao(restricao);
							setModalVisibleEdit(true);
						}}
						className='btn btn-sm btn-primary mr-1'
						data-toggle='modal'
						data-target={'#editarRestricao' + restricao.id + 'Modal'}>
						Editar
					</button>
					{/*<button
						className='btn btn-sm btn-danger'
						onClick={() => {
							removerRestricao(restricao, setLoading);
						}}>
						{loading ? (
							<img className='loadingImg' src={loadingGif} alt='loading' />
						) : (
							'Remover'
						)}
						</button>*/}
				</div>
			</td>
		</tr>
	);
}
